exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alinha_direita{\n\ttext-align: right;\n}\n.botoes{\n\tborder-radius: 10px;\n}\n", ""]);

// exports
